import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AccessDenied from './AccessDenied';

const ProtectedRoute = ({ 
  children, 
  allowedRoles = [], 
  fallback = <AccessDenied /> 
}) => {
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  // Fetch user role from user info API
  const getRole = async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      const url = `${process.env.REACT_APP_API_URL}/user/id/${userId}`;
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const role = response.data.role_name;
      setUserRole(role);
      
      // Check if user has access
      if (allowedRoles.length === 0 || allowedRoles.includes(role)) {
        setHasAccess(true);
      } else {
        setHasAccess(false);
      }
    } catch (error) {
      console.error("Error fetching role:", error);
      setHasAccess(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRole();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!hasAccess) {
    return fallback;
  }

  return children;
};

export default ProtectedRoute; 